







import Vue from 'vue';
import HeaderWrapper from './components/HeaderWrapper.vue';    
import NavBar from "./components/nav/NavBar.vue";
import {CONTEXT_GETTERS, CONTEXT_ACTIONS } from '@shared/store/context';
import { CONTEXT_MODULE_NAMESPACE } from './store/index';
import { mapGetters } from 'vuex';

export default Vue.extend({
    components: {
        HeaderWrapper,
        NavBar
    },
    computed: {
        ...mapGetters(CONTEXT_MODULE_NAMESPACE, {
            context: CONTEXT_GETTERS.CONTEXT_OBJECT
        }),
    },
    created(){
        this.$store.dispatch(CONTEXT_MODULE_NAMESPACE + "/" + CONTEXT_ACTIONS.GET_AND_SET_CONTEXT)
        .then(response => {
            this.$store.dispatch(CONTEXT_MODULE_NAMESPACE + "/" + CONTEXT_ACTIONS.GET_AND_SET_CART_COUNT);
        });
        //showcase view model
        this.$store.dispatch(CONTEXT_MODULE_NAMESPACE + "/" + CONTEXT_ACTIONS.GET_AND_SET_SHOWCASE_MASTER_VIEWMODEL);
    }
})
